import { render } from "./UserComunicazioni.vue?vue&type=template&id=78ffacee&scoped=true"
import script from "./UserComunicazioni.vue?vue&type=script&lang=js"
export * from "./UserComunicazioni.vue?vue&type=script&lang=js"

import "./UserComunicazioni.vue?vue&type=style&index=0&id=78ffacee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ffacee"]])

export default __exports__